/* eslint-disable no-unused-vars */
function initMobileMenu() {
  // Mobi menu
  // $('body .hamburger').on('click', () => {
  //   $('body').toggleClass('mobi-menu-open');
  //   $(this).toggleClass('is-active');
  // });
  // eslint-disable-next-line no-undef,no-new
  const menu = new Mmenu('.page-header .navbar-mobile', {
    offCanvas: {
      position: 'left-front',
    },
    theme: 'light-contrast',
    navbars: [
      {
        position: 'top',
        content: [
          'close',
        ],
      },
    ],
  });
  const api = menu.API;

  $('#menubutton, .mm-btn.mm-btn--close.mm-navbar__btn, body > .mm-blocker').on('click', () => {
    if ($('#navbar-mobile').hasClass('mm-menu--opened') >= 0) {
      api.close();
    } else {
      api.open();
    }
  });
}
